import { apiRequest } from '@/api/client';
import type { AuthTokens } from '@/types';

export interface SignInPayload {
  email: string;
  password: string;
}

export async function signIn(payload: SignInPayload): Promise<AuthTokens> {
  return apiRequest<AuthTokens>('/auth/users/signin', {
    method: 'POST',
    body: payload,
    auth: false,
  });
}

export async function signOut(accessToken: string, sessionId?: string | null): Promise<void> {
  await apiRequest('/auth/users/signout', {
    method: 'POST',
    accessToken,
    sessionId,
  });
}

export async function forgotPassword(email: string): Promise<void> {
  await apiRequest('/auth/users/forgotpassword', {
    method: 'POST',
    body: { email },
    auth: false,
  });
}

export async function confirmForgotPassword(payload: {
  email: string;
  confirmationCode: string;
  password: string;
}): Promise<void> {
  await apiRequest('/auth/users/confirmforgotpassword', {
    method: 'POST',
    body: payload,
    auth: false,
  });
}

export async function refreshToken(
  refreshTokenValue: string,
  sessionId?: string | null,
): Promise<AuthTokens> {
  return apiRequest<AuthTokens>('/auth/users/refreshtoken', {
    method: 'POST',
    body: { refreshToken: refreshTokenValue, sessionId },
    auth: false,
  });
}
